import React from "react";

const Header = (props) => {
  return (
    <div className="header-wrapper">
      <div className="img"></div>
      <h3>Conway's Game of Life</h3>
    </div>
  );
};
export default Header;
